import { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';
import useAuthStore from '../../store/useAuthStore';
import '../../assets/css/InstallBanner.css';
import footerlogo from '../../assets/images/logo-footer.png';

const baseURL = import.meta.env.VITE_APP_API_BASE_URL;

const InstallBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const authStore = useAuthStore.getState();
  const userCreatedDate = authStore.user?.createdAt || new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
  const pdfUrl = `${baseURL}files/pdf/SLAMMMM_Add_to_Home_Screen.pdf`;

  useEffect(() => {
    // Check if mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Check if already dismissed
    const dismissed = localStorage.getItem('installBannerDismissed');
    const addedToHome = localStorage.getItem('addedToHomeScreen');
    
    if (dismissed || addedToHome) return;

    // Check if within first month of account creation
    const accountAge = Date.now() - new Date(userCreatedDate).getTime();
    const oneMonth = 30 * 24 * 60 * 60 * 1000;
    
    if (accountAge < oneMonth) {
      setShowBanner(true);
    }
  }, [userCreatedDate]);

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('installBannerDismissed', Date.now().toString());
  };

  const handleOpenPDF = () => {
    // Open PDF in new tab
    window.open(pdfUrl, '_blank');
  };

  if (!showBanner) return null;

  return (
    <div className="install-banner">
      <div className="install-banner-content">
        <div className="install-banner-left">
          <div className="install-banner-icon">
            <img src={footerlogo} width="50" alt="SLAMMMM" />
          </div>
          <div className="install-banner-text">
            <p className="install-banner-title">Add SLAMMMM to your home screen</p>
            <p className="install-banner-subtitle">Quick access anytime</p>
          </div>
        </div>

        <div className="install-banner-actions">
          <button onClick={handleOpenPDF} className="install-banner-btn-primary">
            <Download size={14} />
            <span className="install-banner-btn-text-full">View Guide</span>
            <span className="install-banner-btn-text-short">Guide</span>
          </button>
          <button onClick={handleDismiss} className="install-banner-btn-close" aria-label="Dismiss">
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallBanner;